<div class="employee-sign-up-success">
  <div class="content">
    <img
      ngSrc="assets/graphic-employee-signup-success.svg"
      alt=""
      class="d-md-none"
      height="142"
      width="212" />
    <h2 class="mt-5 mt-md-0">Success!</h2>
    <p>
      <strong>{{ subTitle }}</strong>
    </p>
    <app-download-app-buttons></app-download-app-buttons>
    <app-router-switch-btn
      title="Go to Login"
      urlLink="/login"></app-router-switch-btn>
  </div>
</div>
